/* src/components/Nav.svelte generated by Svelte v3.55.0 */
import {
	SvelteComponentDev,
	add_flush_callback,
	add_location,
	append_hydration_dev,
	attr_dev,
	bind,
	binding_callbacks,
	check_outros,
	children,
	claim_component,
	claim_element,
	claim_space,
	claim_text,
	create_component,
	destroy_component,
	destroy_each,
	detach_dev,
	dispatch_dev,
	element,
	group_outros,
	init,
	insert_hydration_dev,
	listen_dev,
	mount_component,
	noop,
	run_all,
	safe_not_equal,
	set_data_dev,
	space,
	text,
	toggle_class,
	transition_in,
	transition_out,
	validate_each_argument,
	validate_slots
} from "../../web_modules/svelte/internal.js";

import { getContext } from '../../web_modules/svelte.js';
import Icon from './Icon.js';
import Login from './Login.js';
import Register from './Register.js';
const file = "src/components/Nav.svelte";

function get_each_context(ctx, list, i) {
	const child_ctx = ctx.slice();
	child_ctx[22] = list[i];
	return child_ctx;
}

function get_each_context_1(ctx, list, i) {
	const child_ctx = ctx.slice();
	child_ctx[25] = list[i];
	return child_ctx;
}

// (123:20) {#if hasChildren(menuItem)}
function create_if_block_4(ctx) {
	let div0;
	let button;
	let icon;
	let t0;
	let span;
	let t1_value = `Open ${/*menuItem*/ ctx[22].title} submenu` + "";
	let t1;
	let button_title_value;
	let t2;
	let div1;
	let ul;
	let current;
	let mounted;
	let dispose;

	icon = new Icon({
			props: {
				type: "utility",
				name: "chevrondown",
				classes: "slds-button__icon"
			},
			$$inline: true
		});

	function click_handler() {
		return /*click_handler*/ ctx[12](/*menuItem*/ ctx[22]);
	}

	let each_value_1 = /*menuItem*/ ctx[22].children;
	validate_each_argument(each_value_1);
	let each_blocks = [];

	for (let i = 0; i < each_value_1.length; i += 1) {
		each_blocks[i] = create_each_block_1(get_each_context_1(ctx, each_value_1, i));
	}

	const block = {
		c: function create() {
			div0 = element("div");
			button = element("button");
			create_component(icon.$$.fragment);
			t0 = space();
			span = element("span");
			t1 = text(t1_value);
			t2 = space();
			div1 = element("div");
			ul = element("ul");

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].c();
			}

			this.h();
		},
		l: function claim(nodes) {
			div0 = claim_element(nodes, "DIV", { class: true });
			var div0_nodes = children(div0);

			button = claim_element(div0_nodes, "BUTTON", {
				class: true,
				"aria-haspopup": true,
				title: true
			});

			var button_nodes = children(button);
			claim_component(icon.$$.fragment, button_nodes);
			t0 = claim_space(button_nodes);
			span = claim_element(button_nodes, "SPAN", { class: true });
			var span_nodes = children(span);
			t1 = claim_text(span_nodes, t1_value);
			span_nodes.forEach(detach_dev);
			button_nodes.forEach(detach_dev);
			div0_nodes.forEach(detach_dev);
			t2 = claim_space(nodes);
			div1 = claim_element(nodes, "DIV", { class: true });
			var div1_nodes = children(div1);
			ul = claim_element(div1_nodes, "UL", { class: true, role: true });
			var ul_nodes = children(ul);

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].l(ul_nodes);
			}

			ul_nodes.forEach(detach_dev);
			div1_nodes.forEach(detach_dev);
			this.h();
		},
		h: function hydrate() {
			attr_dev(span, "class", "slds-assistive-text");
			add_location(span, file, 129, 30, 4210);
			attr_dev(button, "class", "slds-button slds-button_icon slds-button_icon slds-context-bar__button");
			attr_dev(button, "aria-haspopup", "true");
			attr_dev(button, "title", button_title_value = `Open ${/*menuItem*/ ctx[22].title} submenu`);
			add_location(button, file, 124, 28, 3782);
			attr_dev(div0, "class", "slds-context-bar__icon-action slds-p-left_none");
			add_location(div0, file, 123, 24, 3693);
			attr_dev(ul, "class", "slds-dropdown__list");
			attr_dev(ul, "role", "menu");
			add_location(ul, file, 133, 28, 4455);
			attr_dev(div1, "class", "slds-dropdown slds-dropdown_right");
			add_location(div1, file, 132, 24, 4379);
		},
		m: function mount(target, anchor) {
			insert_hydration_dev(target, div0, anchor);
			append_hydration_dev(div0, button);
			mount_component(icon, button, null);
			append_hydration_dev(button, t0);
			append_hydration_dev(button, span);
			append_hydration_dev(span, t1);
			insert_hydration_dev(target, t2, anchor);
			insert_hydration_dev(target, div1, anchor);
			append_hydration_dev(div1, ul);

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].m(ul, null);
			}

			current = true;

			if (!mounted) {
				dispose = listen_dev(button, "click", click_handler, false, false, false);
				mounted = true;
			}
		},
		p: function update(new_ctx, dirty) {
			ctx = new_ctx;
			if ((!current || dirty & /*menuItems*/ 1) && t1_value !== (t1_value = `Open ${/*menuItem*/ ctx[22].title} submenu` + "")) set_data_dev(t1, t1_value);

			if (!current || dirty & /*menuItems*/ 1 && button_title_value !== (button_title_value = `Open ${/*menuItem*/ ctx[22].title} submenu`)) {
				attr_dev(button, "title", button_title_value);
			}

			if (dirty & /*closeSubMenu, menuItems*/ 129) {
				each_value_1 = /*menuItem*/ ctx[22].children;
				validate_each_argument(each_value_1);
				let i;

				for (i = 0; i < each_value_1.length; i += 1) {
					const child_ctx = get_each_context_1(ctx, each_value_1, i);

					if (each_blocks[i]) {
						each_blocks[i].p(child_ctx, dirty);
					} else {
						each_blocks[i] = create_each_block_1(child_ctx);
						each_blocks[i].c();
						each_blocks[i].m(ul, null);
					}
				}

				for (; i < each_blocks.length; i += 1) {
					each_blocks[i].d(1);
				}

				each_blocks.length = each_value_1.length;
			}
		},
		i: function intro(local) {
			if (current) return;
			transition_in(icon.$$.fragment, local);
			current = true;
		},
		o: function outro(local) {
			transition_out(icon.$$.fragment, local);
			current = false;
		},
		d: function destroy(detaching) {
			if (detaching) detach_dev(div0);
			destroy_component(icon);
			if (detaching) detach_dev(t2);
			if (detaching) detach_dev(div1);
			destroy_each(each_blocks, detaching);
			mounted = false;
			dispose();
		}
	};

	dispatch_dev("SvelteRegisterBlock", {
		block,
		id: create_if_block_4.name,
		type: "if",
		source: "(123:20) {#if hasChildren(menuItem)}",
		ctx
	});

	return block;
}

// (135:32) {#each menuItem.children as childMenuItem}
function create_each_block_1(ctx) {
	let li;
	let a;
	let span;
	let t0_value = /*childMenuItem*/ ctx[25].title + "";
	let t0;
	let span_title_value;
	let a_href_value;
	let t1;
	let mounted;
	let dispose;

	const block = {
		c: function create() {
			li = element("li");
			a = element("a");
			span = element("span");
			t0 = text(t0_value);
			t1 = space();
			this.h();
		},
		l: function claim(nodes) {
			li = claim_element(nodes, "LI", { class: true, role: true });
			var li_nodes = children(li);
			a = claim_element(li_nodes, "A", { href: true, role: true, tabindex: true });
			var a_nodes = children(a);
			span = claim_element(a_nodes, "SPAN", { class: true, title: true });
			var span_nodes = children(span);
			t0 = claim_text(span_nodes, t0_value);
			span_nodes.forEach(detach_dev);
			a_nodes.forEach(detach_dev);
			t1 = claim_space(li_nodes);
			li_nodes.forEach(detach_dev);
			this.h();
		},
		h: function hydrate() {
			attr_dev(span, "class", "slds-truncate");
			attr_dev(span, "title", span_title_value = /*childMenuItem*/ ctx[25].title);
			add_location(span, file, 137, 44, 4841);
			attr_dev(a, "href", a_href_value = /*childMenuItem*/ ctx[25].url);
			attr_dev(a, "role", "menuitem");
			attr_dev(a, "tabindex", "-1");
			add_location(a, file, 136, 40, 4736);
			attr_dev(li, "class", "slds-dropdown__item");
			attr_dev(li, "role", "presentation");
			add_location(li, file, 135, 36, 4611);
		},
		m: function mount(target, anchor) {
			insert_hydration_dev(target, li, anchor);
			append_hydration_dev(li, a);
			append_hydration_dev(a, span);
			append_hydration_dev(span, t0);
			append_hydration_dev(li, t1);

			if (!mounted) {
				dispose = listen_dev(li, "click", /*click_handler_1*/ ctx[13], false, false, false);
				mounted = true;
			}
		},
		p: function update(ctx, dirty) {
			if (dirty & /*menuItems*/ 1 && t0_value !== (t0_value = /*childMenuItem*/ ctx[25].title + "")) set_data_dev(t0, t0_value);

			if (dirty & /*menuItems*/ 1 && span_title_value !== (span_title_value = /*childMenuItem*/ ctx[25].title)) {
				attr_dev(span, "title", span_title_value);
			}

			if (dirty & /*menuItems*/ 1 && a_href_value !== (a_href_value = /*childMenuItem*/ ctx[25].url)) {
				attr_dev(a, "href", a_href_value);
			}
		},
		d: function destroy(detaching) {
			if (detaching) detach_dev(li);
			mounted = false;
			dispose();
		}
	};

	dispatch_dev("SvelteRegisterBlock", {
		block,
		id: create_each_block_1.name,
		type: "each",
		source: "(135:32) {#each menuItem.children as childMenuItem}",
		ctx
	});

	return block;
}

// (111:12) {#each menuItems as menuItem}
function create_each_block(ctx) {
	let li;
	let a;
	let span;
	let t0_value = /*menuItem*/ ctx[22].title + "";
	let t0;
	let span_title_value;
	let a_href_value;
	let a_title_value;
	let t1;
	let show_if = hasChildren(/*menuItem*/ ctx[22]);
	let t2;
	let current;
	let mounted;
	let dispose;
	let if_block = show_if && create_if_block_4(ctx);

	function click_handler_2() {
		return /*click_handler_2*/ ctx[14](/*menuItem*/ ctx[22]);
	}

	const block = {
		c: function create() {
			li = element("li");
			a = element("a");
			span = element("span");
			t0 = text(t0_value);
			t1 = space();
			if (if_block) if_block.c();
			t2 = space();
			this.h();
		},
		l: function claim(nodes) {
			li = claim_element(nodes, "LI", { class: true });
			var li_nodes = children(li);
			a = claim_element(li_nodes, "A", { href: true, class: true, title: true });
			var a_nodes = children(a);
			span = claim_element(a_nodes, "SPAN", { class: true, title: true });
			var span_nodes = children(span);
			t0 = claim_text(span_nodes, t0_value);
			span_nodes.forEach(detach_dev);
			a_nodes.forEach(detach_dev);
			t1 = claim_space(li_nodes);
			if (if_block) if_block.l(li_nodes);
			t2 = claim_space(li_nodes);
			li_nodes.forEach(detach_dev);
			this.h();
		},
		h: function hydrate() {
			attr_dev(span, "class", "slds-truncate");
			attr_dev(span, "title", span_title_value = /*menuItem*/ ctx[22].title);
			add_location(span, file, 120, 24, 3519);
			attr_dev(a, "href", a_href_value = /*menuItem*/ ctx[22].url || 'javascript:void(0)');
			attr_dev(a, "class", "slds-context-bar__label-action");
			attr_dev(a, "title", a_title_value = /*menuItem*/ ctx[22].title);
			add_location(a, file, 118, 20, 3358);
			attr_dev(li, "class", "slds-context-bar__item");
			toggle_class(li, "slds-is-open", /*menuItem*/ ctx[22] === /*openedMenuItem*/ ctx[1]);
			toggle_class(li, "slds-is-active", /*menuItem*/ ctx[22].active);
			toggle_class(li, "slds-context-bar__dropdown-trigger", hasChildren(/*menuItem*/ ctx[22]));
			toggle_class(li, "slds-dropdown-trigger", hasChildren(/*menuItem*/ ctx[22]));
			toggle_class(li, "slds-dropdown-trigger_click", hasChildren(/*menuItem*/ ctx[22]));
			add_location(li, file, 111, 16, 2878);
		},
		m: function mount(target, anchor) {
			insert_hydration_dev(target, li, anchor);
			append_hydration_dev(li, a);
			append_hydration_dev(a, span);
			append_hydration_dev(span, t0);
			append_hydration_dev(li, t1);
			if (if_block) if_block.m(li, null);
			append_hydration_dev(li, t2);
			current = true;

			if (!mounted) {
				dispose = listen_dev(li, "click", click_handler_2, false, false, false);
				mounted = true;
			}
		},
		p: function update(new_ctx, dirty) {
			ctx = new_ctx;
			if ((!current || dirty & /*menuItems*/ 1) && t0_value !== (t0_value = /*menuItem*/ ctx[22].title + "")) set_data_dev(t0, t0_value);

			if (!current || dirty & /*menuItems*/ 1 && span_title_value !== (span_title_value = /*menuItem*/ ctx[22].title)) {
				attr_dev(span, "title", span_title_value);
			}

			if (!current || dirty & /*menuItems*/ 1 && a_href_value !== (a_href_value = /*menuItem*/ ctx[22].url || 'javascript:void(0)')) {
				attr_dev(a, "href", a_href_value);
			}

			if (!current || dirty & /*menuItems*/ 1 && a_title_value !== (a_title_value = /*menuItem*/ ctx[22].title)) {
				attr_dev(a, "title", a_title_value);
			}

			if (dirty & /*menuItems*/ 1) show_if = hasChildren(/*menuItem*/ ctx[22]);

			if (show_if) {
				if (if_block) {
					if_block.p(ctx, dirty);

					if (dirty & /*menuItems*/ 1) {
						transition_in(if_block, 1);
					}
				} else {
					if_block = create_if_block_4(ctx);
					if_block.c();
					transition_in(if_block, 1);
					if_block.m(li, t2);
				}
			} else if (if_block) {
				group_outros();

				transition_out(if_block, 1, 1, () => {
					if_block = null;
				});

				check_outros();
			}

			if (!current || dirty & /*menuItems, openedMenuItem*/ 3) {
				toggle_class(li, "slds-is-open", /*menuItem*/ ctx[22] === /*openedMenuItem*/ ctx[1]);
			}

			if (!current || dirty & /*menuItems*/ 1) {
				toggle_class(li, "slds-is-active", /*menuItem*/ ctx[22].active);
			}

			if (!current || dirty & /*hasChildren, menuItems*/ 1) {
				toggle_class(li, "slds-context-bar__dropdown-trigger", hasChildren(/*menuItem*/ ctx[22]));
			}

			if (!current || dirty & /*hasChildren, menuItems*/ 1) {
				toggle_class(li, "slds-dropdown-trigger", hasChildren(/*menuItem*/ ctx[22]));
			}

			if (!current || dirty & /*hasChildren, menuItems*/ 1) {
				toggle_class(li, "slds-dropdown-trigger_click", hasChildren(/*menuItem*/ ctx[22]));
			}
		},
		i: function intro(local) {
			if (current) return;
			transition_in(if_block);
			current = true;
		},
		o: function outro(local) {
			transition_out(if_block);
			current = false;
		},
		d: function destroy(detaching) {
			if (detaching) detach_dev(li);
			if (if_block) if_block.d();
			mounted = false;
			dispose();
		}
	};

	dispatch_dev("SvelteRegisterBlock", {
		block,
		id: create_each_block.name,
		type: "each",
		source: "(111:12) {#each menuItems as menuItem}",
		ctx
	});

	return block;
}

// (151:2) {#if !isLoggedIn}
function create_if_block_3(ctx) {
	let div1;
	let div0;
	let span0;
	let t0;
	let t1;
	let div3;
	let div2;
	let span1;
	let t2;
	let mounted;
	let dispose;

	const block = {
		c: function create() {
			div1 = element("div");
			div0 = element("div");
			span0 = element("span");
			t0 = text("Log In");
			t1 = space();
			div3 = element("div");
			div2 = element("div");
			span1 = element("span");
			t2 = text("Register");
			this.h();
		},
		l: function claim(nodes) {
			div1 = claim_element(nodes, "DIV", { class: true });
			var div1_nodes = children(div1);
			div0 = claim_element(div1_nodes, "DIV", { class: true });
			var div0_nodes = children(div0);
			span0 = claim_element(div0_nodes, "SPAN", { class: true, title: true });
			var span0_nodes = children(span0);
			t0 = claim_text(span0_nodes, "Log In");
			span0_nodes.forEach(detach_dev);
			div0_nodes.forEach(detach_dev);
			div1_nodes.forEach(detach_dev);
			t1 = claim_space(nodes);
			div3 = claim_element(nodes, "DIV", { class: true });
			var div3_nodes = children(div3);
			div2 = claim_element(div3_nodes, "DIV", { class: true });
			var div2_nodes = children(div2);
			span1 = claim_element(div2_nodes, "SPAN", { class: true, title: true });
			var span1_nodes = children(span1);
			t2 = claim_text(span1_nodes, "Register");
			span1_nodes.forEach(detach_dev);
			div2_nodes.forEach(detach_dev);
			div3_nodes.forEach(detach_dev);
			this.h();
		},
		h: function hydrate() {
			attr_dev(span0, "class", "slds-truncate");
			attr_dev(span0, "title", "Log In");
			add_location(span0, file, 153, 8, 5530);
			attr_dev(div0, "class", "slds-context-bar__label-action");
			add_location(div0, file, 152, 4, 5443);
			attr_dev(div1, "class", "slds-float_right slds-clearfix slds-context-bar__item slds-context-bar__dropdown-trigger slds-dropdown-trigger slds-dropdown-trigger_click");
			add_location(div1, file, 151, 2, 5286);
			attr_dev(span1, "class", "slds-truncate");
			attr_dev(span1, "title", "Register");
			add_location(span1, file, 159, 6, 5855);
			attr_dev(div2, "class", "slds-context-bar__label-action");
			add_location(div2, file, 158, 4, 5767);
			attr_dev(div3, "class", "slds-float_right slds-clearfix slds-context-bar__item slds-context-bar__dropdown-trigger slds-dropdown-trigger slds-dropdown-trigger_click");
			add_location(div3, file, 157, 2, 5610);
		},
		m: function mount(target, anchor) {
			insert_hydration_dev(target, div1, anchor);
			append_hydration_dev(div1, div0);
			append_hydration_dev(div0, span0);
			append_hydration_dev(span0, t0);
			insert_hydration_dev(target, t1, anchor);
			insert_hydration_dev(target, div3, anchor);
			append_hydration_dev(div3, div2);
			append_hydration_dev(div2, span1);
			append_hydration_dev(span1, t2);

			if (!mounted) {
				dispose = [
					listen_dev(div0, "click", /*click_handler_3*/ ctx[15], false, false, false),
					listen_dev(div2, "click", /*click_handler_4*/ ctx[16], false, false, false)
				];

				mounted = true;
			}
		},
		p: noop,
		d: function destroy(detaching) {
			if (detaching) detach_dev(div1);
			if (detaching) detach_dev(t1);
			if (detaching) detach_dev(div3);
			mounted = false;
			run_all(dispose);
		}
	};

	dispatch_dev("SvelteRegisterBlock", {
		block,
		id: create_if_block_3.name,
		type: "if",
		source: "(151:2) {#if !isLoggedIn}",
		ctx
	});

	return block;
}

// (165:2) {#if isLoggedIn}
function create_if_block_2(ctx) {
	let div1;
	let div0;
	let span0;
	let t0;
	let t1;
	let t2;
	let span1;
	let t3;
	let t4;
	let a;
	let span2;
	let t5;
	let t6;
	let span3;
	let t7;
	let mounted;
	let dispose;

	const block = {
		c: function create() {
			div1 = element("div");
			div0 = element("div");
			span0 = element("span");
			t0 = text("Welcome ");
			t1 = text(/*username*/ ctx[5]);
			t2 = space();
			span1 = element("span");
			t3 = text(" (");
			t4 = space();
			a = element("a");
			span2 = element("span");
			t5 = text("Log Out");
			t6 = space();
			span3 = element("span");
			t7 = text(")");
			this.h();
		},
		l: function claim(nodes) {
			div1 = claim_element(nodes, "DIV", { class: true });
			var div1_nodes = children(div1);
			div0 = claim_element(div1_nodes, "DIV", { class: true });
			var div0_nodes = children(div0);
			span0 = claim_element(div0_nodes, "SPAN", { class: true, title: true });
			var span0_nodes = children(span0);
			t0 = claim_text(span0_nodes, "Welcome ");
			t1 = claim_text(span0_nodes, /*username*/ ctx[5]);
			span0_nodes.forEach(detach_dev);
			t2 = claim_space(div0_nodes);
			span1 = claim_element(div0_nodes, "SPAN", {});
			var span1_nodes = children(span1);
			t3 = claim_text(span1_nodes, " (");
			span1_nodes.forEach(detach_dev);
			t4 = claim_space(div0_nodes);
			a = claim_element(div0_nodes, "A", { href: true, role: true, tabindex: true });
			var a_nodes = children(a);
			span2 = claim_element(a_nodes, "SPAN", { title: true });
			var span2_nodes = children(span2);
			t5 = claim_text(span2_nodes, "Log Out");
			span2_nodes.forEach(detach_dev);
			a_nodes.forEach(detach_dev);
			t6 = claim_space(div0_nodes);
			span3 = claim_element(div0_nodes, "SPAN", {});
			var span3_nodes = children(span3);
			t7 = claim_text(span3_nodes, ")");
			span3_nodes.forEach(detach_dev);
			div0_nodes.forEach(detach_dev);
			div1_nodes.forEach(detach_dev);
			this.h();
		},
		h: function hydrate() {
			attr_dev(span0, "class", "slds-truncate");
			attr_dev(span0, "title", "Register");
			add_location(span0, file, 167, 8, 6167);
			add_location(span1, file, 168, 8, 6246);
			attr_dev(span2, "title", "Log Out");
			add_location(span2, file, 170, 14, 6358);
			attr_dev(a, "href", "");
			attr_dev(a, "role", "menuitem");
			attr_dev(a, "tabindex", "-1");
			add_location(a, file, 169, 8, 6275);
			add_location(span3, file, 172, 8, 6416);
			attr_dev(div0, "class", "slds-context-bar__label-action");
			add_location(div0, file, 166, 6, 6113);
			attr_dev(div1, "class", "slds-float_right slds-clearfix slds-context-bar__item slds-context-bar__dropdown-trigger slds-dropdown-trigger slds-no-hover");
			add_location(div1, file, 165, 4, 5968);
		},
		m: function mount(target, anchor) {
			insert_hydration_dev(target, div1, anchor);
			append_hydration_dev(div1, div0);
			append_hydration_dev(div0, span0);
			append_hydration_dev(span0, t0);
			append_hydration_dev(span0, t1);
			append_hydration_dev(div0, t2);
			append_hydration_dev(div0, span1);
			append_hydration_dev(span1, t3);
			append_hydration_dev(div0, t4);
			append_hydration_dev(div0, a);
			append_hydration_dev(a, span2);
			append_hydration_dev(span2, t5);
			append_hydration_dev(div0, t6);
			append_hydration_dev(div0, span3);
			append_hydration_dev(span3, t7);

			if (!mounted) {
				dispose = listen_dev(a, "click", /*click_handler_5*/ ctx[17], false, false, false);
				mounted = true;
			}
		},
		p: function update(ctx, dirty) {
			if (dirty & /*username*/ 32) set_data_dev(t1, /*username*/ ctx[5]);
		},
		d: function destroy(detaching) {
			if (detaching) detach_dev(div1);
			mounted = false;
			dispose();
		}
	};

	dispatch_dev("SvelteRegisterBlock", {
		block,
		id: create_if_block_2.name,
		type: "if",
		source: "(165:2) {#if isLoggedIn}",
		ctx
	});

	return block;
}

// (178:2) {#if loginFormIsOpened}
function create_if_block_1(ctx) {
	let login;
	let updating_username;
	let updating_loginFormIsOpened;
	let updating_isLoggedIn;
	let current;

	function login_username_binding(value) {
		/*login_username_binding*/ ctx[18](value);
	}

	function login_loginFormIsOpened_binding(value) {
		/*login_loginFormIsOpened_binding*/ ctx[19](value);
	}

	function login_isLoggedIn_binding(value) {
		/*login_isLoggedIn_binding*/ ctx[20](value);
	}

	let login_props = {};

	if (/*username*/ ctx[5] !== void 0) {
		login_props.username = /*username*/ ctx[5];
	}

	if (/*loginFormIsOpened*/ ctx[2] !== void 0) {
		login_props.loginFormIsOpened = /*loginFormIsOpened*/ ctx[2];
	}

	if (/*isLoggedIn*/ ctx[4] !== void 0) {
		login_props.isLoggedIn = /*isLoggedIn*/ ctx[4];
	}

	login = new Login({ props: login_props, $$inline: true });
	binding_callbacks.push(() => bind(login, 'username', login_username_binding, /*username*/ ctx[5]));
	binding_callbacks.push(() => bind(login, 'loginFormIsOpened', login_loginFormIsOpened_binding, /*loginFormIsOpened*/ ctx[2]));
	binding_callbacks.push(() => bind(login, 'isLoggedIn', login_isLoggedIn_binding, /*isLoggedIn*/ ctx[4]));

	const block = {
		c: function create() {
			create_component(login.$$.fragment);
		},
		l: function claim(nodes) {
			claim_component(login.$$.fragment, nodes);
		},
		m: function mount(target, anchor) {
			mount_component(login, target, anchor);
			current = true;
		},
		p: function update(ctx, dirty) {
			const login_changes = {};

			if (!updating_username && dirty & /*username*/ 32) {
				updating_username = true;
				login_changes.username = /*username*/ ctx[5];
				add_flush_callback(() => updating_username = false);
			}

			if (!updating_loginFormIsOpened && dirty & /*loginFormIsOpened*/ 4) {
				updating_loginFormIsOpened = true;
				login_changes.loginFormIsOpened = /*loginFormIsOpened*/ ctx[2];
				add_flush_callback(() => updating_loginFormIsOpened = false);
			}

			if (!updating_isLoggedIn && dirty & /*isLoggedIn*/ 16) {
				updating_isLoggedIn = true;
				login_changes.isLoggedIn = /*isLoggedIn*/ ctx[4];
				add_flush_callback(() => updating_isLoggedIn = false);
			}

			login.$set(login_changes);
		},
		i: function intro(local) {
			if (current) return;
			transition_in(login.$$.fragment, local);
			current = true;
		},
		o: function outro(local) {
			transition_out(login.$$.fragment, local);
			current = false;
		},
		d: function destroy(detaching) {
			destroy_component(login, detaching);
		}
	};

	dispatch_dev("SvelteRegisterBlock", {
		block,
		id: create_if_block_1.name,
		type: "if",
		source: "(178:2) {#if loginFormIsOpened}",
		ctx
	});

	return block;
}

// (186:2) {#if registerFormIsOpened}
function create_if_block(ctx) {
	let register;
	let updating_registerFormIsOpened;
	let current;

	function register_registerFormIsOpened_binding(value) {
		/*register_registerFormIsOpened_binding*/ ctx[21](value);
	}

	let register_props = {};

	if (/*registerFormIsOpened*/ ctx[3] !== void 0) {
		register_props.registerFormIsOpened = /*registerFormIsOpened*/ ctx[3];
	}

	register = new Register({ props: register_props, $$inline: true });
	binding_callbacks.push(() => bind(register, 'registerFormIsOpened', register_registerFormIsOpened_binding, /*registerFormIsOpened*/ ctx[3]));

	const block = {
		c: function create() {
			create_component(register.$$.fragment);
		},
		l: function claim(nodes) {
			claim_component(register.$$.fragment, nodes);
		},
		m: function mount(target, anchor) {
			mount_component(register, target, anchor);
			current = true;
		},
		p: function update(ctx, dirty) {
			const register_changes = {};

			if (!updating_registerFormIsOpened && dirty & /*registerFormIsOpened*/ 8) {
				updating_registerFormIsOpened = true;
				register_changes.registerFormIsOpened = /*registerFormIsOpened*/ ctx[3];
				add_flush_callback(() => updating_registerFormIsOpened = false);
			}

			register.$set(register_changes);
		},
		i: function intro(local) {
			if (current) return;
			transition_in(register.$$.fragment, local);
			current = true;
		},
		o: function outro(local) {
			transition_out(register.$$.fragment, local);
			current = false;
		},
		d: function destroy(detaching) {
			destroy_component(register, detaching);
		}
	};

	dispatch_dev("SvelteRegisterBlock", {
		block,
		id: create_if_block.name,
		type: "if",
		source: "(186:2) {#if registerFormIsOpened}",
		ctx
	});

	return block;
}

function create_fragment(ctx) {
	let div2;
	let div1;
	let div0;
	let span1;
	let span0;
	let t0;
	let t1;
	let nav;
	let ul;
	let t2;
	let t3;
	let t4;
	let t5;
	let current;
	let each_value = /*menuItems*/ ctx[0];
	validate_each_argument(each_value);
	let each_blocks = [];

	for (let i = 0; i < each_value.length; i += 1) {
		each_blocks[i] = create_each_block(get_each_context(ctx, each_value, i));
	}

	const out = i => transition_out(each_blocks[i], 1, 1, () => {
		each_blocks[i] = null;
	});

	let if_block0 = !/*isLoggedIn*/ ctx[4] && create_if_block_3(ctx);
	let if_block1 = /*isLoggedIn*/ ctx[4] && create_if_block_2(ctx);
	let if_block2 = /*loginFormIsOpened*/ ctx[2] && create_if_block_1(ctx);
	let if_block3 = /*registerFormIsOpened*/ ctx[3] && create_if_block(ctx);

	const block = {
		c: function create() {
			div2 = element("div");
			div1 = element("div");
			div0 = element("div");
			span1 = element("span");
			span0 = element("span");
			t0 = text(appName);
			t1 = space();
			nav = element("nav");
			ul = element("ul");

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].c();
			}

			t2 = space();
			if (if_block0) if_block0.c();
			t3 = space();
			if (if_block1) if_block1.c();
			t4 = space();
			if (if_block2) if_block2.c();
			t5 = space();
			if (if_block3) if_block3.c();
			this.h();
		},
		l: function claim(nodes) {
			div2 = claim_element(nodes, "DIV", { class: true });
			var div2_nodes = children(div2);
			div1 = claim_element(div2_nodes, "DIV", { class: true });
			var div1_nodes = children(div1);
			div0 = claim_element(div1_nodes, "DIV", { class: true });
			var div0_nodes = children(div0);
			span1 = claim_element(div0_nodes, "SPAN", { class: true });
			var span1_nodes = children(span1);
			span0 = claim_element(span1_nodes, "SPAN", { class: true, title: true });
			var span0_nodes = children(span0);
			t0 = claim_text(span0_nodes, appName);
			span0_nodes.forEach(detach_dev);
			span1_nodes.forEach(detach_dev);
			div0_nodes.forEach(detach_dev);
			div1_nodes.forEach(detach_dev);
			t1 = claim_space(div2_nodes);
			nav = claim_element(div2_nodes, "NAV", { class: true, role: true });
			var nav_nodes = children(nav);
			ul = claim_element(nav_nodes, "UL", { class: true });
			var ul_nodes = children(ul);

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].l(ul_nodes);
			}

			ul_nodes.forEach(detach_dev);
			nav_nodes.forEach(detach_dev);
			t2 = claim_space(div2_nodes);
			if (if_block0) if_block0.l(div2_nodes);
			t3 = claim_space(div2_nodes);
			if (if_block1) if_block1.l(div2_nodes);
			t4 = claim_space(div2_nodes);
			if (if_block2) if_block2.l(div2_nodes);
			t5 = claim_space(div2_nodes);
			if (if_block3) if_block3.l(div2_nodes);
			div2_nodes.forEach(detach_dev);
			this.h();
		},
		h: function hydrate() {
			attr_dev(span0, "class", "slds-truncate");
			attr_dev(span0, "title", appName);
			add_location(span0, file, 103, 16, 2615);
			attr_dev(span1, "class", "slds-context-bar__label-action slds-context-bar__app-name");
			add_location(span1, file, 102, 12, 2526);
			attr_dev(div0, "class", "slds-context-bar__item slds-context-bar__dropdown-trigger slds-dropdown-trigger slds-dropdown-trigger_click slds-no-hover");
			add_location(div0, file, 101, 8, 2378);
			attr_dev(div1, "class", "slds-context-bar__primary");
			add_location(div1, file, 100, 4, 2330);
			attr_dev(ul, "class", "slds-grid");
			add_location(ul, file, 109, 8, 2797);
			attr_dev(nav, "class", "slds-context-bar__secondary");
			attr_dev(nav, "role", "navigation");
			add_location(nav, file, 108, 4, 2729);
			attr_dev(div2, "class", "slds-context-bar");
			add_location(div2, file, 99, 0, 2295);
		},
		m: function mount(target, anchor) {
			insert_hydration_dev(target, div2, anchor);
			append_hydration_dev(div2, div1);
			append_hydration_dev(div1, div0);
			append_hydration_dev(div0, span1);
			append_hydration_dev(span1, span0);
			append_hydration_dev(span0, t0);
			append_hydration_dev(div2, t1);
			append_hydration_dev(div2, nav);
			append_hydration_dev(nav, ul);

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].m(ul, null);
			}

			append_hydration_dev(div2, t2);
			if (if_block0) if_block0.m(div2, null);
			append_hydration_dev(div2, t3);
			if (if_block1) if_block1.m(div2, null);
			append_hydration_dev(div2, t4);
			if (if_block2) if_block2.m(div2, null);
			append_hydration_dev(div2, t5);
			if (if_block3) if_block3.m(div2, null);
			current = true;
		},
		p: function update(ctx, [dirty]) {
			if (dirty & /*menuItems, openedMenuItem, hasChildren, closeSubMenu, openSubMenu*/ 195) {
				each_value = /*menuItems*/ ctx[0];
				validate_each_argument(each_value);
				let i;

				for (i = 0; i < each_value.length; i += 1) {
					const child_ctx = get_each_context(ctx, each_value, i);

					if (each_blocks[i]) {
						each_blocks[i].p(child_ctx, dirty);
						transition_in(each_blocks[i], 1);
					} else {
						each_blocks[i] = create_each_block(child_ctx);
						each_blocks[i].c();
						transition_in(each_blocks[i], 1);
						each_blocks[i].m(ul, null);
					}
				}

				group_outros();

				for (i = each_value.length; i < each_blocks.length; i += 1) {
					out(i);
				}

				check_outros();
			}

			if (!/*isLoggedIn*/ ctx[4]) {
				if (if_block0) {
					if_block0.p(ctx, dirty);
				} else {
					if_block0 = create_if_block_3(ctx);
					if_block0.c();
					if_block0.m(div2, t3);
				}
			} else if (if_block0) {
				if_block0.d(1);
				if_block0 = null;
			}

			if (/*isLoggedIn*/ ctx[4]) {
				if (if_block1) {
					if_block1.p(ctx, dirty);
				} else {
					if_block1 = create_if_block_2(ctx);
					if_block1.c();
					if_block1.m(div2, t4);
				}
			} else if (if_block1) {
				if_block1.d(1);
				if_block1 = null;
			}

			if (/*loginFormIsOpened*/ ctx[2]) {
				if (if_block2) {
					if_block2.p(ctx, dirty);

					if (dirty & /*loginFormIsOpened*/ 4) {
						transition_in(if_block2, 1);
					}
				} else {
					if_block2 = create_if_block_1(ctx);
					if_block2.c();
					transition_in(if_block2, 1);
					if_block2.m(div2, t5);
				}
			} else if (if_block2) {
				group_outros();

				transition_out(if_block2, 1, 1, () => {
					if_block2 = null;
				});

				check_outros();
			}

			if (/*registerFormIsOpened*/ ctx[3]) {
				if (if_block3) {
					if_block3.p(ctx, dirty);

					if (dirty & /*registerFormIsOpened*/ 8) {
						transition_in(if_block3, 1);
					}
				} else {
					if_block3 = create_if_block(ctx);
					if_block3.c();
					transition_in(if_block3, 1);
					if_block3.m(div2, null);
				}
			} else if (if_block3) {
				group_outros();

				transition_out(if_block3, 1, 1, () => {
					if_block3 = null;
				});

				check_outros();
			}
		},
		i: function intro(local) {
			if (current) return;

			for (let i = 0; i < each_value.length; i += 1) {
				transition_in(each_blocks[i]);
			}

			transition_in(if_block2);
			transition_in(if_block3);
			current = true;
		},
		o: function outro(local) {
			each_blocks = each_blocks.filter(Boolean);

			for (let i = 0; i < each_blocks.length; i += 1) {
				transition_out(each_blocks[i]);
			}

			transition_out(if_block2);
			transition_out(if_block3);
			current = false;
		},
		d: function destroy(detaching) {
			if (detaching) detach_dev(div2);
			destroy_each(each_blocks, detaching);
			if (if_block0) if_block0.d();
			if (if_block1) if_block1.d();
			if (if_block2) if_block2.d();
			if (if_block3) if_block3.d();
		}
	};

	dispatch_dev("SvelteRegisterBlock", {
		block,
		id: create_fragment.name,
		type: "component",
		source: "",
		ctx
	});

	return block;
}

const appName = 'eCommerce';

function hasChildren(menuItem) {
	return menuItem.children && menuItem.children.length;
}

function instance($$self, $$props, $$invalidate) {
	let { $$slots: slots = {}, $$scope } = $$props;
	validate_slots('Nav', slots, []);
	let { segment } = $$props;

	let menuItems = [
		{ title: 'Home', url: '/', active: false },
		{
			title: 'Products',
			children: [
				{
					title: 'Product View',
					url: '/products/view'
				},
				{
					title: 'Product List',
					url: '/products/list'
				}
			],
			active: false
		},
		{
			title: 'Cart',
			children: [
				{ title: 'View Cart', url: '/cart' },
				{ title: 'Checkout', url: '/cart/checkout' }
			],
			active: false
		},
		{
			title: 'Orders',
			url: '/orders',
			active: false
		}
	];

	let openedMenuItem = null;

	function openSubMenu(menuItem) {
		$$invalidate(1, openedMenuItem = openedMenuItem === menuItem ? null : menuItem);
	}

	function closeSubMenu(menuItem) {
		if (openedMenuItem !== menuItem) {
			$$invalidate(1, openedMenuItem = null);
		}
	}

	let loginFormIsOpened = false;
	let registerFormIsOpened = false;
	let isLoggedIn = false;
	let username;

	function openLoginForm() {
		$$invalidate(2, loginFormIsOpened = true);
	}

	function openRegisterForm() {
		$$invalidate(3, registerFormIsOpened = true);
	}

	function logOut() {
		$$invalidate(4, isLoggedIn = false);
	}

	// account for the baseUrl in the navigation items
	getContext('baseUrl').subscribe(baseUrl => {
		$$invalidate(0, menuItems = menuItems.map(menuItem => {
			if (menuItem.url) {
				menuItem.url = baseUrl + menuItem.url;
			}

			if (menuItem.children) {
				menuItem.children.forEach(child => {
					child.url = baseUrl + child.url;
				});
			}

			return menuItem;
		}));
	});

	$$self.$$.on_mount.push(function () {
		if (segment === undefined && !('segment' in $$props || $$self.$$.bound[$$self.$$.props['segment']])) {
			console.warn("<Nav> was created without expected prop 'segment'");
		}
	});

	const writable_props = ['segment'];

	Object.keys($$props).forEach(key => {
		if (!~writable_props.indexOf(key) && key.slice(0, 2) !== '$$' && key !== 'slot') console.warn(`<Nav> was created with unknown prop '${key}'`);
	});

	const click_handler = menuItem => openSubMenu(menuItem);
	const click_handler_1 = () => closeSubMenu();
	const click_handler_2 = menuItem => closeSubMenu(menuItem);
	const click_handler_3 = () => openLoginForm();
	const click_handler_4 = () => openRegisterForm();
	const click_handler_5 = () => logOut();

	function login_username_binding(value) {
		username = value;
		$$invalidate(5, username);
	}

	function login_loginFormIsOpened_binding(value) {
		loginFormIsOpened = value;
		$$invalidate(2, loginFormIsOpened);
	}

	function login_isLoggedIn_binding(value) {
		isLoggedIn = value;
		$$invalidate(4, isLoggedIn);
	}

	function register_registerFormIsOpened_binding(value) {
		registerFormIsOpened = value;
		$$invalidate(3, registerFormIsOpened);
	}

	$$self.$$set = $$props => {
		if ('segment' in $$props) $$invalidate(11, segment = $$props.segment);
	};

	$$self.$capture_state = () => ({
		getContext,
		Icon,
		Login,
		Register,
		segment,
		appName,
		menuItems,
		openedMenuItem,
		hasChildren,
		openSubMenu,
		closeSubMenu,
		loginFormIsOpened,
		registerFormIsOpened,
		isLoggedIn,
		username,
		openLoginForm,
		openRegisterForm,
		logOut
	});

	$$self.$inject_state = $$props => {
		if ('segment' in $$props) $$invalidate(11, segment = $$props.segment);
		if ('menuItems' in $$props) $$invalidate(0, menuItems = $$props.menuItems);
		if ('openedMenuItem' in $$props) $$invalidate(1, openedMenuItem = $$props.openedMenuItem);
		if ('loginFormIsOpened' in $$props) $$invalidate(2, loginFormIsOpened = $$props.loginFormIsOpened);
		if ('registerFormIsOpened' in $$props) $$invalidate(3, registerFormIsOpened = $$props.registerFormIsOpened);
		if ('isLoggedIn' in $$props) $$invalidate(4, isLoggedIn = $$props.isLoggedIn);
		if ('username' in $$props) $$invalidate(5, username = $$props.username);
	};

	if ($$props && "$$inject" in $$props) {
		$$self.$inject_state($$props.$$inject);
	}

	$$self.$$.update = () => {
		if ($$self.$$.dirty & /*segment, menuItems*/ 2049) {
			$: {
				try {
					const url = `/${segment || ''}`;

					$$invalidate(0, menuItems = menuItems.map((menuItem, i) => {
						if (!segment) {
							menuItem.active = i === 0;
						} else {
							const urls = menuItem.url
							? [menuItem.url]
							: menuItem.children.map(childMenuItem => childMenuItem.url);

							menuItem.active = urls.some(v => v.startsWith(url));
						}

						return menuItem;
					}));
				} catch(e) {
					$$invalidate(0, menuItems[0].active = true, menuItems);
				}
			}
		}
	};

	return [
		menuItems,
		openedMenuItem,
		loginFormIsOpened,
		registerFormIsOpened,
		isLoggedIn,
		username,
		openSubMenu,
		closeSubMenu,
		openLoginForm,
		openRegisterForm,
		logOut,
		segment,
		click_handler,
		click_handler_1,
		click_handler_2,
		click_handler_3,
		click_handler_4,
		click_handler_5,
		login_username_binding,
		login_loginFormIsOpened_binding,
		login_isLoggedIn_binding,
		register_registerFormIsOpened_binding
	];
}

class Nav extends SvelteComponentDev {
	constructor(options) {
		super(options);
		init(this, options, instance, create_fragment, safe_not_equal, { segment: 11 });

		dispatch_dev("SvelteRegisterComponent", {
			component: this,
			tagName: "Nav",
			options,
			id: create_fragment.name
		});
	}

	get segment() {
		throw new Error("<Nav>: Props cannot be read directly from the component instance unless compiling with 'accessors: true' or '<svelte:options accessors/>'");
	}

	set segment(value) {
		throw new Error("<Nav>: Props cannot be set directly on the component instance unless compiling with 'accessors: true' or '<svelte:options accessors/>'");
	}
}

export default Nav;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6W10sInNvdXJjZXMiOlsiTmF2LnN2ZWx0ZSJdLCJzb3VyY2VzQ29udGVudCI6WyI8c2NyaXB0PlxuICBpbXBvcnQgeyBnZXRDb250ZXh0IH0gZnJvbSAnc3ZlbHRlJ1xuICBpbXBvcnQgSWNvbiBmcm9tICckY29tcG9uZW50cy9JY29uLnN2ZWx0ZSdcbiAgaW1wb3J0IExvZ2luIGZyb20gJyRjb21wb25lbnRzL0xvZ2luLnN2ZWx0ZSdcbiAgaW1wb3J0IFJlZ2lzdGVyIGZyb20gJyRjb21wb25lbnRzL1JlZ2lzdGVyLnN2ZWx0ZSdcblxuICBleHBvcnQgbGV0IHNlZ21lbnRcblxuICBjb25zdCBhcHBOYW1lID0gJ2VDb21tZXJjZSdcblxuICBsZXQgbWVudUl0ZW1zID0gW1xuICAgIHsgdGl0bGU6ICdIb21lJywgdXJsOiAnLycsIGFjdGl2ZTogZmFsc2UgfSxcbiAgICB7XG4gICAgICB0aXRsZTogJ1Byb2R1Y3RzJyxcbiAgICAgIGNoaWxkcmVuOiBbXG4gICAgICAgIHsgdGl0bGU6ICdQcm9kdWN0IFZpZXcnLCB1cmw6ICcvcHJvZHVjdHMvdmlldycgfSxcbiAgICAgICAgeyB0aXRsZTogJ1Byb2R1Y3QgTGlzdCcsIHVybDogJy9wcm9kdWN0cy9saXN0JyB9XG4gICAgICBdLFxuICAgICAgYWN0aXZlOiBmYWxzZVxuICAgIH0sXG4gICAge1xuICAgICAgdGl0bGU6ICdDYXJ0JyxcbiAgICAgIGNoaWxkcmVuOiBbXG4gICAgICAgIHsgdGl0bGU6ICdWaWV3IENhcnQnLCB1cmw6ICcvY2FydCcgfSxcbiAgICAgICAgeyB0aXRsZTogJ0NoZWNrb3V0JywgdXJsOiAnL2NhcnQvY2hlY2tvdXQnIH0sXG4gICAgICBdLFxuICAgICAgYWN0aXZlOiBmYWxzZVxuICAgIH0sXG4gICAgeyB0aXRsZTogJ09yZGVycycsIHVybDogJy9vcmRlcnMnLCBhY3RpdmU6IGZhbHNlIH1cbiAgXVxuXG4gIGxldCBvcGVuZWRNZW51SXRlbSA9IG51bGxcblxuICAkOiB7XG4gICAgdHJ5IHtcbiAgICAgIGNvbnN0IHVybCA9IGAvJHtzZWdtZW50IHx8ICcnfWBcbiAgICAgIG1lbnVJdGVtcyA9IG1lbnVJdGVtcy5tYXAoKG1lbnVJdGVtLCBpKSA9PiB7XG4gICAgICAgIGlmICghc2VnbWVudCkge1xuICAgICAgICAgIG1lbnVJdGVtLmFjdGl2ZSA9IGkgPT09IDBcbiAgICAgICAgfSBlbHNlIHtcbiAgICAgICAgICBjb25zdCB1cmxzID0gbWVudUl0ZW0udXJsXG4gICAgICAgICAgICA/IFttZW51SXRlbS51cmxdXG4gICAgICAgICAgICA6IG1lbnVJdGVtLmNoaWxkcmVuLm1hcChjaGlsZE1lbnVJdGVtID0+IGNoaWxkTWVudUl0ZW0udXJsKVxuICAgICAgICAgIG1lbnVJdGVtLmFjdGl2ZSA9IHVybHMuc29tZSh2ID0+IHYuc3RhcnRzV2l0aCh1cmwpKVxuICAgICAgICB9XG4gICAgICAgIHJldHVybiBtZW51SXRlbVxuICAgICAgfSlcbiAgICB9IGNhdGNoIChlKSB7XG4gICAgICBtZW51SXRlbXNbMF0uYWN0aXZlID0gdHJ1ZVxuICAgIH1cbiAgfVxuXG4gIGZ1bmN0aW9uIGhhc0NoaWxkcmVuIChtZW51SXRlbSkge1xuICAgIHJldHVybiBtZW51SXRlbS5jaGlsZHJlbiAmJiBtZW51SXRlbS5jaGlsZHJlbi5sZW5ndGhcbiAgfVxuXG4gIGZ1bmN0aW9uIG9wZW5TdWJNZW51IChtZW51SXRlbSkge1xuICAgIG9wZW5lZE1lbnVJdGVtID0gb3BlbmVkTWVudUl0ZW0gPT09IG1lbnVJdGVtID8gbnVsbCA6IG1lbnVJdGVtXG4gIH1cblxuICBmdW5jdGlvbiBjbG9zZVN1Yk1lbnUgKG1lbnVJdGVtKSB7XG4gICAgaWYgKG9wZW5lZE1lbnVJdGVtICE9PSBtZW51SXRlbSkge1xuICAgICAgb3BlbmVkTWVudUl0ZW0gPSBudWxsXG4gICAgfVxuICB9XG5cbiAgbGV0IGxvZ2luRm9ybUlzT3BlbmVkID0gZmFsc2U7XG4gIGxldCByZWdpc3RlckZvcm1Jc09wZW5lZCA9IGZhbHNlO1xuICBsZXQgaXNMb2dnZWRJbiA9IGZhbHNlO1xuICBsZXQgdXNlcm5hbWU7XG5cbiAgZnVuY3Rpb24gb3BlbkxvZ2luRm9ybSgpIHtcbiAgICBsb2dpbkZvcm1Jc09wZW5lZCA9IHRydWU7XG4gIH1cblxuICBmdW5jdGlvbiBvcGVuUmVnaXN0ZXJGb3JtKCkge1xuICAgIHJlZ2lzdGVyRm9ybUlzT3BlbmVkID0gdHJ1ZTtcbiAgfVxuXG4gIGZ1bmN0aW9uIGxvZ091dCgpIHtcbiAgICBpc0xvZ2dlZEluID0gZmFsc2U7XG4gIH1cblxuICAvLyBhY2NvdW50IGZvciB0aGUgYmFzZVVybCBpbiB0aGUgbmF2aWdhdGlvbiBpdGVtc1xuICBnZXRDb250ZXh0KCdiYXNlVXJsJykuc3Vic2NyaWJlKGJhc2VVcmwgPT4ge1xuICAgIG1lbnVJdGVtcyA9IG1lbnVJdGVtcy5tYXAobWVudUl0ZW0gPT4ge1xuICAgICAgaWYgKG1lbnVJdGVtLnVybCkge1xuICAgICAgICBtZW51SXRlbS51cmwgPSBiYXNlVXJsICsgbWVudUl0ZW0udXJsXG4gICAgICB9XG4gICAgICBpZiAobWVudUl0ZW0uY2hpbGRyZW4pIHtcbiAgICAgICAgbWVudUl0ZW0uY2hpbGRyZW4uZm9yRWFjaChjaGlsZCA9PiB7XG4gICAgICAgICAgY2hpbGQudXJsID0gYmFzZVVybCArIGNoaWxkLnVybFxuICAgICAgICB9KVxuICAgICAgfVxuICAgICAgcmV0dXJuIG1lbnVJdGVtXG4gICAgfSlcbiAgfSlcbjwvc2NyaXB0PlxuXG48ZGl2IGNsYXNzPVwic2xkcy1jb250ZXh0LWJhclwiPlxuICAgIDxkaXYgY2xhc3M9XCJzbGRzLWNvbnRleHQtYmFyX19wcmltYXJ5XCI+XG4gICAgICAgIDxkaXYgY2xhc3M9XCJzbGRzLWNvbnRleHQtYmFyX19pdGVtIHNsZHMtY29udGV4dC1iYXJfX2Ryb3Bkb3duLXRyaWdnZXIgc2xkcy1kcm9wZG93bi10cmlnZ2VyIHNsZHMtZHJvcGRvd24tdHJpZ2dlcl9jbGljayBzbGRzLW5vLWhvdmVyXCI+XG4gICAgICAgICAgICA8c3BhbiBjbGFzcz1cInNsZHMtY29udGV4dC1iYXJfX2xhYmVsLWFjdGlvbiBzbGRzLWNvbnRleHQtYmFyX19hcHAtbmFtZVwiPlxuICAgICAgICAgICAgICAgIDxzcGFuIGNsYXNzPVwic2xkcy10cnVuY2F0ZVwiIHRpdGxlPVwie2FwcE5hbWV9XCI+e2FwcE5hbWV9PC9zcGFuPlxuICAgICAgICAgICAgPC9zcGFuPlxuICAgICAgICA8L2Rpdj5cbiAgICA8L2Rpdj5cblxuICAgIDxuYXYgY2xhc3M9XCJzbGRzLWNvbnRleHQtYmFyX19zZWNvbmRhcnlcIiByb2xlPVwibmF2aWdhdGlvblwiPlxuICAgICAgICA8dWwgY2xhc3M9XCJzbGRzLWdyaWRcIj5cbiAgICAgICAgICAgIHsjZWFjaCBtZW51SXRlbXMgYXMgbWVudUl0ZW19XG4gICAgICAgICAgICAgICAgPGxpIGNsYXNzPVwic2xkcy1jb250ZXh0LWJhcl9faXRlbVwiXG4gICAgICAgICAgICAgICAgICAgIGNsYXNzOnNsZHMtaXMtb3Blbj17bWVudUl0ZW0gPT09IG9wZW5lZE1lbnVJdGVtfVxuICAgICAgICAgICAgICAgICAgICBjbGFzczpzbGRzLWlzLWFjdGl2ZT17bWVudUl0ZW0uYWN0aXZlfVxuICAgICAgICAgICAgICAgICAgICBjbGFzczpzbGRzLWNvbnRleHQtYmFyX19kcm9wZG93bi10cmlnZ2VyPXtoYXNDaGlsZHJlbihtZW51SXRlbSl9XG4gICAgICAgICAgICAgICAgICAgIGNsYXNzOnNsZHMtZHJvcGRvd24tdHJpZ2dlcj17aGFzQ2hpbGRyZW4obWVudUl0ZW0pfVxuICAgICAgICAgICAgICAgICAgICBjbGFzczpzbGRzLWRyb3Bkb3duLXRyaWdnZXJfY2xpY2s9e2hhc0NoaWxkcmVuKG1lbnVJdGVtKX1cbiAgICAgICAgICAgICAgICAgICAgb246Y2xpY2s9eygpID0+IGNsb3NlU3ViTWVudShtZW51SXRlbSkgfT5cbiAgICAgICAgICAgICAgICAgICAgPGEgaHJlZj1cInttZW51SXRlbS51cmwgfHwgJ2phdmFzY3JpcHQ6dm9pZCgwKSd9XCIgY2xhc3M9XCJzbGRzLWNvbnRleHQtYmFyX19sYWJlbC1hY3Rpb25cIlxuICAgICAgICAgICAgICAgICAgICAgICB0aXRsZT1cInttZW51SXRlbS50aXRsZX1cIj5cbiAgICAgICAgICAgICAgICAgICAgICAgIDxzcGFuIGNsYXNzPVwic2xkcy10cnVuY2F0ZVwiIHRpdGxlPVwie21lbnVJdGVtLnRpdGxlfVwiPnttZW51SXRlbS50aXRsZX08L3NwYW4+XG4gICAgICAgICAgICAgICAgICAgIDwvYT5cbiAgICAgICAgICAgICAgICAgICAgeyNpZiBoYXNDaGlsZHJlbihtZW51SXRlbSl9XG4gICAgICAgICAgICAgICAgICAgICAgICA8ZGl2IGNsYXNzPVwic2xkcy1jb250ZXh0LWJhcl9faWNvbi1hY3Rpb24gc2xkcy1wLWxlZnRfbm9uZVwiPlxuICAgICAgICAgICAgICAgICAgICAgICAgICAgIDxidXR0b24gY2xhc3M9XCJzbGRzLWJ1dHRvbiBzbGRzLWJ1dHRvbl9pY29uIHNsZHMtYnV0dG9uX2ljb24gc2xkcy1jb250ZXh0LWJhcl9fYnV0dG9uXCJcbiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIGFyaWEtaGFzcG9wdXA9XCJ0cnVlXCJcbiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIHRpdGxlPXtgT3BlbiAke21lbnVJdGVtLnRpdGxlfSBzdWJtZW51YH1cbiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIG9uOmNsaWNrPXsoKSA9PiBvcGVuU3ViTWVudShtZW51SXRlbSl9PlxuICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgPEljb24gdHlwZT1cInV0aWxpdHlcIiBuYW1lPVwiY2hldnJvbmRvd25cIiBjbGFzc2VzPVwic2xkcy1idXR0b25fX2ljb25cIiAvPlxuICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgPHNwYW4gY2xhc3M9XCJzbGRzLWFzc2lzdGl2ZS10ZXh0XCI+e2BPcGVuICR7bWVudUl0ZW0udGl0bGV9IHN1Ym1lbnVgfTwvc3Bhbj5cbiAgICAgICAgICAgICAgICAgICAgICAgICAgICA8L2J1dHRvbj5cbiAgICAgICAgICAgICAgICAgICAgICAgIDwvZGl2PlxuICAgICAgICAgICAgICAgICAgICAgICAgPGRpdiBjbGFzcz1cInNsZHMtZHJvcGRvd24gc2xkcy1kcm9wZG93bl9yaWdodFwiPlxuICAgICAgICAgICAgICAgICAgICAgICAgICAgIDx1bCBjbGFzcz1cInNsZHMtZHJvcGRvd25fX2xpc3RcIiByb2xlPVwibWVudVwiPlxuICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICB7I2VhY2ggbWVudUl0ZW0uY2hpbGRyZW4gYXMgY2hpbGRNZW51SXRlbX1cbiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIDxsaSBjbGFzcz1cInNsZHMtZHJvcGRvd25fX2l0ZW1cIiByb2xlPVwicHJlc2VudGF0aW9uXCIgb246Y2xpY2s9eygpID0+IGNsb3NlU3ViTWVudSgpfT5cbiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICA8YSBocmVmPVwie2NoaWxkTWVudUl0ZW0udXJsfVwiIHJvbGU9XCJtZW51aXRlbVwiIHRhYmluZGV4PVwiLTFcIj5cbiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgPHNwYW4gY2xhc3M9XCJzbGRzLXRydW5jYXRlXCJcbiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgdGl0bGU9XCJ7Y2hpbGRNZW51SXRlbS50aXRsZX1cIj57Y2hpbGRNZW51SXRlbS50aXRsZX08L3NwYW4+XG4gICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgPC9hPlxuICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgPC9saT5cbiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgey9lYWNofVxuICAgICAgICAgICAgICAgICAgICAgICAgICAgIDwvdWw+XG4gICAgICAgICAgICAgICAgICAgICAgICA8L2Rpdj5cbiAgICAgICAgICAgICAgICAgICAgey9pZn1cbiAgICAgICAgICAgICAgICA8L2xpPlxuICAgICAgICAgICAgey9lYWNofVxuICAgICAgICA8L3VsPlxuICAgIDwvbmF2PlxuXG4gIHsjaWYgIWlzTG9nZ2VkSW59XG4gIDxkaXYgY2xhc3M9XCJzbGRzLWZsb2F0X3JpZ2h0IHNsZHMtY2xlYXJmaXggc2xkcy1jb250ZXh0LWJhcl9faXRlbSBzbGRzLWNvbnRleHQtYmFyX19kcm9wZG93bi10cmlnZ2VyIHNsZHMtZHJvcGRvd24tdHJpZ2dlciBzbGRzLWRyb3Bkb3duLXRyaWdnZXJfY2xpY2tcIj5cbiAgICA8ZGl2IGNsYXNzPVwic2xkcy1jb250ZXh0LWJhcl9fbGFiZWwtYWN0aW9uXCIgb246Y2xpY2s9eygpID0+IG9wZW5Mb2dpbkZvcm0oKSB9PlxuICAgICAgICA8c3BhbiBjbGFzcz1cInNsZHMtdHJ1bmNhdGVcIiB0aXRsZT1cIkxvZyBJblwiPkxvZyBJbjwvc3Bhbj5cbiAgICA8L2Rpdj5cbiAgPC9kaXY+XG5cbiAgPGRpdiBjbGFzcz1cInNsZHMtZmxvYXRfcmlnaHQgc2xkcy1jbGVhcmZpeCBzbGRzLWNvbnRleHQtYmFyX19pdGVtIHNsZHMtY29udGV4dC1iYXJfX2Ryb3Bkb3duLXRyaWdnZXIgc2xkcy1kcm9wZG93bi10cmlnZ2VyIHNsZHMtZHJvcGRvd24tdHJpZ2dlcl9jbGlja1wiPlxuICAgIDxkaXYgY2xhc3M9XCJzbGRzLWNvbnRleHQtYmFyX19sYWJlbC1hY3Rpb25cIiBvbjpjbGljaz17KCkgPT4gb3BlblJlZ2lzdGVyRm9ybSgpIH0+XG4gICAgICA8c3BhbiBjbGFzcz1cInNsZHMtdHJ1bmNhdGVcIiB0aXRsZT1cIlJlZ2lzdGVyXCI+UmVnaXN0ZXI8L3NwYW4+XG4gICAgPC9kaXY+XG4gIDwvZGl2PlxuICB7L2lmfVxuXG4gIHsjaWYgaXNMb2dnZWRJbn1cbiAgICA8ZGl2IGNsYXNzPVwic2xkcy1mbG9hdF9yaWdodCBzbGRzLWNsZWFyZml4IHNsZHMtY29udGV4dC1iYXJfX2l0ZW0gc2xkcy1jb250ZXh0LWJhcl9fZHJvcGRvd24tdHJpZ2dlciBzbGRzLWRyb3Bkb3duLXRyaWdnZXIgc2xkcy1uby1ob3ZlclwiPlxuICAgICAgPGRpdiBjbGFzcz1cInNsZHMtY29udGV4dC1iYXJfX2xhYmVsLWFjdGlvblwiID5cbiAgICAgICAgPHNwYW4gY2xhc3M9XCJzbGRzLXRydW5jYXRlXCIgdGl0bGU9XCJSZWdpc3RlclwiPldlbGNvbWUge3VzZXJuYW1lfTwvc3Bhbj5cbiAgICAgICAgPHNwYW4+Jm5ic3A7KDwvc3Bhbj5cbiAgICAgICAgPGEgaHJlZj1cIlwiIHJvbGU9XCJtZW51aXRlbVwiIHRhYmluZGV4PVwiLTFcIiBvbjpjbGljaz17KCkgPT4gbG9nT3V0KCkgfT5cbiAgICAgICAgICAgICAgPHNwYW4gdGl0bGU9XCJMb2cgT3V0XCI+TG9nIE91dDwvc3Bhbj5cbiAgICAgICAgPC9hPlxuICAgICAgICA8c3Bhbj4pPC9zcGFuPlxuICAgICAgPC9kaXY+XG4gICAgPC9kaXY+XG4gIHsvaWZ9XG5cbiAgeyNpZiBsb2dpbkZvcm1Jc09wZW5lZH1cbiAgICA8TG9naW5cbiAgICAgIGJpbmQ6dXNlcm5hbWU9e3VzZXJuYW1lfVxuICAgICAgYmluZDpsb2dpbkZvcm1Jc09wZW5lZD17bG9naW5Gb3JtSXNPcGVuZWR9XG4gICAgICBiaW5kOmlzTG9nZ2VkSW49e2lzTG9nZ2VkSW59XG4gICAgLz5cbiAgey9pZn1cblxuICB7I2lmIHJlZ2lzdGVyRm9ybUlzT3BlbmVkfVxuICAgIDxSZWdpc3RlclxuICAgICAgYmluZDpyZWdpc3RlckZvcm1Jc09wZW5lZD17cmVnaXN0ZXJGb3JtSXNPcGVuZWR9XG4gICAgLz5cbiAgey9pZn1cblxuPC9kaXY+XG4iXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztTQUNXLFVBQVUsUUFBUSxRQUFRO09BQzVCLElBQUksTUFBTSx5QkFBeUI7T0FDbkMsS0FBSyxNQUFNLDBCQUEwQjtPQUNyQyxRQUFRLE1BQU0sNkJBQTZCOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O3FDQTZIcUIsR0FBUSxLQUFDLEtBQUs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O2lDQUtoRCxHQUFRLEtBQUMsUUFBUTs7OztrQ0FBdEIsTUFBSTs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O3VFQVJhLEdBQVEsS0FBQyxLQUFLOzs7Ozs7Ozs7OztHQUh6QyxvQkFRTTtHQVBGLG9CQU1TOzs7R0FEUCxvQkFBMkU7OztHQUdqRixvQkFXTTtHQVZGLG9CQVNLOzs7Ozs7Ozs7Ozs7Ozs7OEZBYndDLEdBQVEsS0FBQyxLQUFLOztnSEFIcEMsR0FBUSxLQUFDLEtBQUs7Ozs7O2dDQVExQixHQUFRLEtBQUMsUUFBUTs7OztpQ0FBdEIsTUFBSTs7Ozs7Ozs7Ozs7Ozs7OztzQ0FBSixNQUFJOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7a0NBSTJDLEdBQWEsS0FBQyxLQUFLOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Z0VBQTFDLEdBQWEsS0FBQyxLQUFLOzt3REFGM0IsR0FBYSxLQUFDLEdBQUc7Ozs7Ozs7OztHQUQvQixvQkFLSztHQUpELG9CQUdJO0dBRkEsb0JBQ2dFOzs7Ozs7Ozs7OzZFQUEzQixHQUFhLEtBQUMsS0FBSzs7NkZBQTFDLEdBQWEsS0FBQyxLQUFLOzs7O3FGQUYzQixHQUFhLEtBQUMsR0FBRzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OzZCQWhCVyxHQUFRLEtBQUMsS0FBSzs7Ozs7O2VBRW5FLFdBQVcsY0FBQyxHQUFROzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OzJEQUZlLEdBQVEsS0FBQyxLQUFLOzttREFGNUMsR0FBUSxLQUFDLEdBQUcsSUFBSSxvQkFBb0I7O3FEQUNuQyxHQUFRLEtBQUMsS0FBSzs7O2lEQVBMLEdBQVEsNEJBQUssR0FBYzttREFDekIsR0FBUSxLQUFDLE1BQU07MERBQ0ssV0FBVyxjQUFDLEdBQVE7NkNBQ2pDLFdBQVcsY0FBQyxHQUFRO21EQUNkLFdBQVcsY0FBQyxHQUFROzs7O0dBTDNELG9CQWtDSztHQTNCRCxvQkFHSTtHQURBLG9CQUE0RTs7Ozs7Ozs7Ozs7Ozs7c0ZBQXRCLEdBQVEsS0FBQyxLQUFLOztvR0FBaEMsR0FBUSxLQUFDLEtBQUs7Ozs7NEZBRjVDLEdBQVEsS0FBQyxHQUFHLElBQUksb0JBQW9COzs7OzhGQUNuQyxHQUFRLEtBQUMsS0FBSzs7OzswQ0FHcEIsV0FBVyxjQUFDLEdBQVE7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O2tEQVZMLEdBQVEsNEJBQUssR0FBYzs7OztvREFDekIsR0FBUSxLQUFDLE1BQU07Ozs7MkRBQ0ssV0FBVyxjQUFDLEdBQVE7Ozs7OENBQ2pDLFdBQVcsY0FBQyxHQUFROzs7O29EQUNkLFdBQVcsY0FBQyxHQUFROzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OzthQXFDeEIsUUFBTTs7Ozs7YUFNTixVQUFROzs7Ozs7Ozs7O2dDQU5SLFFBQU07Ozs7Ozs7Ozs7O2dDQU1OLFVBQVE7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0dBUnpELG9CQUlNO0dBSEosb0JBRU07R0FERixvQkFBd0Q7OztHQUk5RCxvQkFJTTtHQUhKLG9CQUVNO0dBREosb0JBQTREOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O2FBUWIsVUFBUTswQkFBQyxHQUFROzs7YUFDeEQsSUFBTzs7OzthQUVlLFNBQU87OzthQUU3QixHQUFDOzs7Ozs7Ozs7O2dDQUxzQyxVQUFROzZDQUFDLEdBQVE7Ozs7O2dDQUN4RCxJQUFPOzs7Ozs7O2dDQUVlLFNBQU87Ozs7OztnQ0FFN0IsR0FBQzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0dBUFgsb0JBU007R0FSSixvQkFPTTtHQU5KLG9CQUFzRTs7OztHQUN0RSxvQkFBb0I7OztHQUNwQixvQkFFSTtHQURFLG9CQUFvQzs7O0dBRTFDLG9CQUFjOzs7Ozs7Ozs7OERBTHdDLEdBQVE7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztrQkFZakQsR0FBUTtzQ0FBUixHQUFROzs7MkJBQ0MsR0FBaUI7d0RBQWpCLEdBQWlCOzs7b0JBQ3hCLEdBQVU7MENBQVYsR0FBVTs7OzsyRkFGWixHQUFRO3NIQUNDLEdBQWlCO2lHQUN4QixHQUFVOzs7Ozs7Ozs7Ozs7Ozs7Ozs7MENBRlosR0FBUTs7Ozs7OzREQUNDLEdBQWlCOzs7Ozs7OENBQ3hCLEdBQVU7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OEJBTUEsR0FBb0I7aUVBQXBCLEdBQW9COzs7O3FJQUFwQixHQUFvQjs7Ozs7Ozs7Ozs7Ozs7Ozs7O3FFQUFwQixHQUFvQjs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztnQ0E3RWxDLEdBQVM7Ozs7Z0NBQWQsTUFBSTs7Ozs7Ozs7aUNBd0NWLEdBQVU7Z0NBY1gsR0FBVTt1Q0FhVixHQUFpQjswQ0FRakIsR0FBb0I7Ozs7Ozs7OzthQWxGb0MsT0FBTzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O2dDQUFQLE9BQU87Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs0QkFBbEIsT0FBTzs7Ozs7Ozs7Ozs7Ozs7Ozs7R0FKM0Qsb0JBNEZNO0dBM0ZGLG9CQU1NO0dBTEYsb0JBSU07R0FIRixvQkFFTztHQURILG9CQUE4RDs7O0dBSzFFLG9CQXdDTTtHQXZDRixvQkFzQ0s7Ozs7Ozs7Ozs7Ozs7Ozs7OzsrQkFyQ00sR0FBUzs7OzsrQkFBZCxNQUFJOzs7Ozs7Ozs7Ozs7Ozs7O3dCQUFKLE1BQUk7Ozs7Ozs7dUJBd0NWLEdBQVU7Ozs7Ozs7Ozs7Ozs7c0JBY1gsR0FBVTs7Ozs7Ozs7Ozs7Ozs2QkFhVixHQUFpQjs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Z0NBUWpCLEdBQW9COzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztrQ0EzRWIsTUFBSTs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztNQXRHVixPQUFPLEdBQUcsV0FBVzs7U0E0Q2xCLFdBQVcsQ0FBRSxRQUFRO1FBQ3JCLFFBQVEsQ0FBQyxRQUFRLElBQUksUUFBUSxDQUFDLFFBQVEsQ0FBQyxNQUFNOzs7Ozs7T0EvQzNDLE9BQU87O0tBSWQsU0FBUztJQUNULEtBQUssRUFBRSxNQUFNLEVBQUUsR0FBRyxFQUFFLEdBQUcsRUFBRSxNQUFNLEVBQUUsS0FBSzs7R0FFdEMsS0FBSyxFQUFFLFVBQVU7R0FDakIsUUFBUTs7S0FDSixLQUFLLEVBQUUsY0FBYztLQUFFLEdBQUcsRUFBRSxnQkFBZ0I7OztLQUM1QyxLQUFLLEVBQUUsY0FBYztLQUFFLEdBQUcsRUFBRSxnQkFBZ0I7OztHQUVoRCxNQUFNLEVBQUUsS0FBSzs7O0dBR2IsS0FBSyxFQUFFLE1BQU07R0FDYixRQUFRO01BQ0osS0FBSyxFQUFFLFdBQVcsRUFBRSxHQUFHLEVBQUUsT0FBTztNQUNoQyxLQUFLLEVBQUUsVUFBVSxFQUFFLEdBQUcsRUFBRSxnQkFBZ0I7O0dBRTVDLE1BQU0sRUFBRSxLQUFLOzs7R0FFYixLQUFLLEVBQUUsUUFBUTtHQUFFLEdBQUcsRUFBRSxTQUFTO0dBQUUsTUFBTSxFQUFFLEtBQUs7Ozs7S0FHOUMsY0FBYyxHQUFHLElBQUk7O1VBeUJoQixXQUFXLENBQUUsUUFBUTtrQkFDNUIsY0FBYyxHQUFHLGNBQWMsS0FBSyxRQUFRLEdBQUcsSUFBSSxHQUFHLFFBQVE7OztVQUd2RCxZQUFZLENBQUUsUUFBUTtNQUN6QixjQUFjLEtBQUssUUFBUTttQkFDN0IsY0FBYyxHQUFHLElBQUk7Ozs7S0FJckIsaUJBQWlCLEdBQUcsS0FBSztLQUN6QixvQkFBb0IsR0FBRyxLQUFLO0tBQzVCLFVBQVUsR0FBRyxLQUFLO0tBQ2xCLFFBQVE7O1VBRUgsYUFBYTtrQkFDcEIsaUJBQWlCLEdBQUcsSUFBSTs7O1VBR2pCLGdCQUFnQjtrQkFDdkIsb0JBQW9CLEdBQUcsSUFBSTs7O1VBR3BCLE1BQU07a0JBQ2IsVUFBVSxHQUFHLEtBQUs7Ozs7Q0FJcEIsVUFBVSxDQUFDLFNBQVMsRUFBRSxTQUFTLENBQUMsT0FBTztrQkFDckMsU0FBUyxHQUFHLFNBQVMsQ0FBQyxHQUFHLENBQUMsUUFBUTtPQUM1QixRQUFRLENBQUMsR0FBRztJQUNkLFFBQVEsQ0FBQyxHQUFHLEdBQUcsT0FBTyxHQUFHLFFBQVEsQ0FBQyxHQUFHOzs7T0FFbkMsUUFBUSxDQUFDLFFBQVE7SUFDbkIsUUFBUSxDQUFDLFFBQVEsQ0FBQyxPQUFPLENBQUMsS0FBSztLQUM3QixLQUFLLENBQUMsR0FBRyxHQUFHLE9BQU8sR0FBRyxLQUFLLENBQUMsR0FBRzs7OztVQUc1QixRQUFROzs7Ozs7Ozs7Ozs7Ozs7O21DQWlDK0IsV0FBVyxDQUFDLFFBQVE7K0JBUWdDLFlBQVk7cUNBbEJoRixZQUFZLENBQUMsUUFBUTsrQkFtQ08sYUFBYTsrQkFNYixnQkFBZ0I7K0JBV2YsTUFBTTs7O0VBVWxELFFBQVE7Ozs7O0VBQ0MsaUJBQWlCOzs7OztFQUN4QixVQUFVOzs7OztFQU1BLG9CQUFvQjs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0dBMUpuRCxDQUFDOztXQUVTLEdBQUcsT0FBTyxPQUFPLElBQUksRUFBRTs7cUJBQzdCLFNBQVMsR0FBRyxTQUFTLENBQUMsR0FBRyxFQUFFLFFBQVEsRUFBRSxDQUFDO1dBQy9CLE9BQU87T0FDVixRQUFRLENBQUMsTUFBTSxHQUFHLENBQUMsS0FBSyxDQUFDOzthQUVuQixJQUFJLEdBQUcsUUFBUSxDQUFDLEdBQUc7VUFDcEIsUUFBUSxDQUFDLEdBQUc7U0FDYixRQUFRLENBQUMsUUFBUSxDQUFDLEdBQUcsQ0FBQyxhQUFhLElBQUksYUFBYSxDQUFDLEdBQUc7O09BQzVELFFBQVEsQ0FBQyxNQUFNLEdBQUcsSUFBSSxDQUFDLElBQUksQ0FBQyxDQUFDLElBQUksQ0FBQyxDQUFDLFVBQVUsQ0FBQyxHQUFHOzs7YUFFNUMsUUFBUTs7WUFFVixDQUFDO3FCQUNSLFNBQVMsQ0FBQyxDQUFDLEVBQUUsTUFBTSxHQUFHLElBQUk7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OzsifQ==
//# sourceMappingURL=Nav.js.map
